import { EnumCacheEntityType } from "@/app/services/generated/enums/enumCacheEntityType.generated";
import {
  EntityWithGuidKeyCache,
  EntityCacheStore,
} from "@/app/caching/apiCache";
import type { CollectionTime } from "@/app/services/generated/collectiontimeService";
import { collectionTimeService } from "@/app/services/generated/collectiontimeService";

export interface IHasCollectionTimesCache {
  collectionTimes: CollectionTimesCache;
}

// Singleton cache store
const collectionTimesCacheStore = new EntityCacheStore<CollectionTime>(
  EnumCacheEntityType.collectionTime,
  async () => collectionTimeService.getAllCollectionTimes()
);

// Ephemeral reader
export default class CollectionTimesCache extends EntityWithGuidKeyCache<CollectionTime> {
  constructor() {
    super(collectionTimesCacheStore, (x) => x.id);
  }
}
